import React, { useMemo } from 'react';
import { Users, ChefHat, Coffee, Briefcase } from 'lucide-react';
import StatCard from '../dashboard/StatCard';

const KITCHEN_ROLES = new Set(['CHEF', 'SOUS_CHEF', 'KITCHEN_HELPER', 'DISHWASHER']);
const FOH_ROLES = new Set(['WAITER', 'CAPTAIN', 'STEWARD']);
const SUPPORT_ROLES = new Set(['CASHIER', 'CLEANER', 'DELIVERY', 'MANAGER', 'OTHER']);

function StatStrip({ employees }) {
  const { active, total, kitchen, foh, support } = useMemo(() => ({
    active: employees.filter(e => e.isActive).length,
    total: employees.length,
    kitchen: employees.filter(e => KITCHEN_ROLES.has(e.jobRole)).length,
    foh: employees.filter(e => FOH_ROLES.has(e.jobRole)).length,
    support: employees.filter(e => SUPPORT_ROLES.has(e.jobRole)).length,
  }), [employees]);

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 px-6 pb-4">
      <StatCard
        icon={<Users size={15} />}
        label="Active staff"
        value={active}
        subtitle={`of ${total} total`}
      />
      <StatCard
        icon={<ChefHat size={15} />}
        label="Chefs & kitchen"
        value={kitchen}
      />
      <StatCard
        icon={<Coffee size={15} />}
        label="Front of house"
        value={foh}
      />
      <StatCard
        icon={<Briefcase size={15} />}
        label="Support & ops"
        value={support}
      />
    </div>
  );
}

export default StatStrip;